module.exports = __webpack_public_path__ + "static/media/Basal_3145.77b7dc0e.jpg";